export const metrics = [{
  label: 'Coaches activos',
  value: '+500'
}, {
  label: 'Tomos Maestros',
  value: '12'
}, {
  label: 'Bonos incluidos',
  value: '5'
}, {
  label: 'Calificación',
  value: '4.9/5'
}, {
  label: 'Garantía de satisfacción',
  value: '7 días sin preguntas'
}];
export const testimonials = [{
  quote: "Organicé todo el año en una tarde. El check list de pista me ahorra más de 3 horas cada semana. Esto no tiene precio.",
  name: 'Marcela G.',
  country: 'España'
}, {
  quote: 'Los tomos de táctica de pareja cambiaron la forma en que enseño. Mis alumnos progresan el doble de rápido y me lo dicen ellos mismos.',
  name: 'Luis P.',
  country: "Argentina"
}, {
  quote: "Mis clases grupales dejaron de ser un caos. El sistema sistema de seguimiento es un antes y un después absoluto en mi academia.",
  name: 'Roberto M.',
  country: 'Colombia'
}];
export const painPoints = ['Llegas al domingo sin saber exactamente qué vas a preparar para cada grupo.', 'Terminas buscando ejercicios en YouTube o Instagram a último momento.', 'Tienes alumnos de distintos niveles y te cuesta ordenar la clase para cada uno.', 'Sabes que tus alumnos mejoran, pero no tienes cómo demostrárselo con evidencia real.', 'Quieres cobrar más por tus horas, pero no sabes cómo justificar ese aumento.', 'La lluvia, la cancha ocupada o un grupo sin energía te obligan a improvisar todo.', 'El fin de semana termina y vuelves a empezar el mismo ciclo agotador el próximo lunes.'];
export const tomos = [{
  id: 'T01',
  title: "Mindset del Coach Pro",
  description: 'De profe por hora a dueño de academia. El cambio de mentalidad que lo cambia todo.'
}, {
  id: 'T02',
  title: 'Biomecánica de Fondo',
  description: 'Golpes de fondo con técnica depurada. La base que todo alumno necesita dominar.'
}, {
  id: 'T03',
  title: 'El Juego de Red',
  description: 'Volea, bandeja y recursos de red. Donde se ganan los partidos de club.'
}, {
  id: 'T04',
  title: 'Defensa con Paredes',
  description: 'El arte de la pared y contrapared. La habilidad que separa al intermedio del avanzado.'
}, {
  id: 'T05',
  title: 'El Smash: Potencia y Efectos',
  description: 'Técnica, posicionamiento y variantes del golpe más deseado por tus alumnos.'
}, {
  id: 'T06',
  title: 'Táctica de Pareja',
  description: 'Comunicación, rotaciones y posicionamiento. Enseña a jugar en equipo de verdad.'
}, {
  id: 'T07',
  title: 'Plan Mensual Iniciación',
  description: '4 semanas de clases listas para usar. Abre el PDF y empieza en 5 minutos.'
}, {
  id: 'T08',
  title: 'Plan Semanal Intermedio',
  description: 'Progresiones reales para alumnos que quieren dejar de ser intermedios para siempre.'
}, {
  id: 'T09',
  title: 'Preparación Física en Cancha',
  description: 'Calentamiento, coordinación y circuitos específicos sin necesitar un gimnasio.'
}, {
  id: 'T10',
  title: 'Psicología de Grupos',
  description: 'Cómo manejar grupos difíciles, alumnos sin motivación y clases con energía baja.'
}, {
  id: 'T11',
  title: 'El Negocio del Pádel',
  description: 'Cómo empaquetar tus servicios, subir tus precios y vender sin sentirte un vendedor.'
}, {
  id: 'T12',
  title: 'Métricas y Fidelización',
  description: 'Mide el progreso de tus alumnos y haz que nunca quieran irse con otro coach.'
}];
export const includes = ['Acceso digital inmediato tras el pago', 'Para nivel Inicial, Intermedio y Avanzado', 'Funciona para clases individuales y grupales', 'Lo abres desde el celular, tablet o computadora', 'Diseñado para coaches de habla hispana en todo el mundo', 'Compatible con cualquier club, cancha o academia'];
export const bonuses = [{
  number: '01',
  title: 'Padel Tracker Pro: El Sistema de Seguimiento',
  value: '$14 USD',
  description: 'Deja de anotar en papeles que se pierden. Esta herramienta te permite registrar el progreso técnico, táctico y físico de hasta 50 alumnos simultáneamente. Al final del mes, generas un reporte de progreso que justifica por qué tus clases valen más que las del resto. El primer alumno que lo vea no va a querer irse jamás.'
}, {
  number: '02',
  title: 'WhatsApp Sales Scripts',
  value: '$12 USD',
  description: '¿Se te canceló una clase a último momento? No pierdas dinero. Copia y pega estos 5 guiones probados de alta conversión para reactivar alumnos antiguos, llenar horarios vacíos y vender paquetes de 10 clases por adelantado. Sin sonar desesperado. Sin improvisar el mensaje.'
}, {
  number: '03',
  title: 'La "Checklist de Pista" del Coach de Élite',
  value: '$10 USD',
  description: 'La profesionalidad está en los detalles. Esta lista interactiva garantiza que cada clase sea perfecta: desde el equipo necesario y el estado de las pelotas, hasta los 3 puntos clave de feedback que todo alumno debe recibir antes de irse de la cancha.'
}, {
  number: '04',
  title: 'Guía Nutricional para Jugadores de Club',
  value: '$10 USD',
  description: 'Un recurso listo para entregar directamente a tus alumnos. Contiene consejos prácticos de hidratación y alimentación pre y post partido. Entregarlo te posiciona como un coach integral 360 y aumenta el rendimiento de tus alumnos. Ellos mejorarán y lo atribuirán a tu sistema.'
}, {
  number: '05',
  title: 'Video-Análisis Express',
  value: '$8 USD',
  description: 'Aprende a usar tu móvil para corregir a tus alumnos como si estuvieras en el World Padel Tour. Te enseñamos los 3 ángulos críticos para grabar cada golpe y qué apps gratuitas usar para dibujar líneas de corrección técnica que dejarán a tus alumnos con la boca abierta.'
}];
export const costOfInaction = [{
  without: '3 horas de planificación × 48 semanas',
  cost: '144 horas de tu vida por año'
}, {
  without: 'Alumnos sin progreso visible',
  cost: 'Abandono alto — ingresos inestables'
}, {
  without: 'Clases grupales improvisadas',
  cost: 'Energía quemada — calidad baja'
}, {
  without: 'Sin sistema de cobros ni agenda',
  cost: 'Dinero perdido cada semana'
}, {
  without: 'Sin variantes por nivel',
  cost: 'Alumnos frustrados y desconectados'
}, {
  without: 'Sin feedback ni seguimiento',
  cost: 'El mismo ciclo de búsqueda de alumnos'
}, {
  without: 'Cada domingo buscando en internet',
  cost: 'El mismo ciclo — el próximo año también'
}];
export const faqs = [{
  question: '¿Sirve para todos los niveles de pádel?',
  answer: 'Sí. El Pro-Pack incluye planificaciones, ejercicios y progresiones específicas para nivel Inicial, Intermedio y Avanzado. Sin importar la mezcla de alumnos que tengas, siempre tendrás el recurso correcto a mano.'
}, {
  question: '¿Cómo recibo el material?',
  answer: 'Al confirmar el pago, recibes un email con acceso inmediato a todos los PDFs. En menos de 5 minutos ya puedes abrir el Tomo 1 desde tu celular, tablet o computadora.'
}, {
  question: '¿Funciona si doy clases individuales y grupales?',
  answer: 'Absolutamente. El sistema está diseñado para ambos formatos. Cada tomo incluye variantes de adaptación para sesiones 1 a 1 y para grupos de hasta 12 personas.'
}, {
  question: '¿Qué lo diferencia de buscar ejercicios en YouTube?',
  answer: 'YouTube te da información aleatoria sin estructura ni progresión. El Padel Pro-Pack™ es un sistema metodológico de 12 Tomos que conecta cada ejercicio con un objetivo pedagógico claro. Es la diferencia entre improvisar y planificar con evidencia.'
}, {
  question: '¿Para qué países está disponible?',
  answer: 'Para todo el mundo hispanohablante: España, México, Colombia, Chile, Argentina, Perú, Uruguay, Ecuador, Paraguay, Bolivia, Costa Rica, Guatemala, Honduras, El Salvador, Nicaragua, Panamá, República Dominicana, Cuba y Estados Unidos (comunidad hispana).'
}, {
  question: '¿Tiene garantía real?',
  answer: 'Sí. 7 días completos. Si no te convence, te devolvemos el 100% sin hacer preguntas. Menos del 1% de nuestros clientes la han utilizado.'
}];
export const CHECKOUT_URL = 'https://padel-pro-pack.impultienda.ar/checkout';
export const images = {
  heroPack: 'https://cdn.magicpatterns.com/uploads/9LFeQSqaberr7G8J9UqLMv/ChatGPT_Image_12_ago_2026,_17_08_14.png',
  courtBg: 'https://cdn.magicpatterns.com/patterns/generated-images/5922b7c0-4082-406b-a4bf-9286996a70df.jpg',
  tomos: 'https://cdn.magicpatterns.com/patterns/generated-images/381bbab1-be32-4a18-92c0-0b238bc51f6f.jpg'
};